module.exports = __webpack_public_path__ + "img/上下翻转3.b5e98a0f.svg";